/*
 * @Author: CAIPENG\CaiPeng 405532928@qq.com
 * @Date: 2023-06-25 00:25:19
 * @LastEditors: CAIPENG\CaiPeng 405532928@qq.com
 * @LastEditTime: 2023-06-26 22:48:36
 * @FilePath: \xm-runing-main\src\router\routes\modules\go-app-base.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import {t} from "@/hooks/web/useI18n";

export default  [
  {
    path: '/flowBpmList/flowMainPage',
    name: 'flowBpmList-flowMainPage',
    meta: {
      orderNo: 8,
      icon: 'ion:grid-outline',
      keepAlive: true,
      title: t('流程信息'),
    },
    children:[
      {
        path: '/flowBpmList/flowList/simplFlowDeal',
        name: 'flowBpmList-simplFlowDeal',
        meta: {
          orderNo: 1,
          icon: 'ion:grid-outline',
          title: t('流程处理'),
        },
        component: () => import(/* webpackChunkName: "vue3Des" */'@/views/flowList/flowDeal/simplFlowDeal.vue'),
      },
      {
        path: '/flowBpmList/proDeal/waitDeal',
        name: 'flowBpmList-waitDeal',
        meta: {
          orderNo: 1,
          icon: 'ion:grid-outline',
          title: t('我的待办'),
        },
        component: () => import(/* webpackChunkName: "vue3Des" */'@/views/flowBpmList/subPages/waitDeal.vue'),
      },
      {
        path: '/flowBpmList/proDeal/myPro',
        name: 'flowBpmList-myPro',
        meta: {
          orderNo: 1,
          icon: 'ion:grid-outline',
          title: t('我的申请'),
        },
        component: () => import(/* webpackChunkName: "vue3Des" */'@/views/flowBpmList/subPages/myPro.vue'),
      },
      {
        path: '/flowBpmList/proDeal/alreadyDeal',
        name: 'flowBpmList-alreadyDeal',
        meta: {
          orderNo: 1,
          icon: 'ion:grid-outline',
          title: t('我已处理'),
        },
        component: () => import(/* webpackChunkName: "vue3Des" */'@/views/flowBpmList/subPages/alreadyDeal.vue'),
      },
      {
        path: '/flowBpmList/proDeal/copySendMe',
        name: 'flowBpmList-copySendMe',
        meta: {
          orderNo: 1,
          icon: 'ion:grid-outline',
          title: t('我已抄送'),
        },
        component: () => import(/* webpackChunkName: "vue3Des" */'@/views/flowBpmList/subPages/copySendMe.vue'),
      },
    ],
    component: () => import(/* webpackChunkName: "sysLog" */'@/views/flowBpmList/flowMainPage.vue'),
  },
  {
    path: '/flowList/flowMainPage',
    name: 'flowMainPage',
    meta: {
      orderNo: 8,
      icon: 'ion:grid-outline',
      keepAlive: true,
      title: t('流程信息'),
    },
    children:[
      {
        path: '/flowList/simplFlowDeal',
        name: 'simplFlowDeal',
        meta: {
          orderNo: 1,
          icon: 'ion:grid-outline',
          title: t('流程处理'),
        },
        component: () => import(/* webpackChunkName: "vue3Des" */'@/views/flowList/flowDeal/simplFlowDeal.vue'),
      },
      {
        path: '/flowList/waitDeal',
        name: 'waitDeal',
        meta: {
          orderNo: 1,
          icon: 'ion:grid-outline',
          title: t('流程待办'),
        },
        component: () => import(/* webpackChunkName: "vue3Des" */'@/views/flowList/subPages/waitDeal.vue'),
      },
      {
        path: '/flowList/myPro',
        name: 'myPro',
        meta: {
          orderNo: 1,
          icon: 'ion:grid-outline',
          title: t('我的申请'),
        },
        component: () => import(/* webpackChunkName: "vue3Des" */'@/views/flowList/subPages/myPro.vue'),
      },
      {
        path: '/flowList/alreadyDeal',
        name: 'alreadyDeal',
        meta: {
          orderNo: 1,
          icon: 'ion:grid-outline',
          title: t('我已处理'),
        },
        component: () => import(/* webpackChunkName: "vue3Des" */'@/views/flowList/subPages/alreadyDeal.vue'),
      },
      {
        path: '/flowList/copySendMe',
        name: 'copySendMe',
        meta: {
          orderNo: 1,
          icon: 'ion:grid-outline',
          title: t('我已抄送'),
        },
        component: () => import(/* webpackChunkName: "vue3Des" */'@/views/flowList/subPages/copySendMe.vue'),
      },
    ],
    component: () => import(/* webpackChunkName: "sysLog" */'@/views/flowList/flowMainPage.vue'),
  }
]
